<template>
    <v-app id="inspire">
        <v-layout row justify-center>
            <!-- If app type is not ep -->
            <v-dialog persistent scrollable v-model="dialog" width="60%" v-if="app != 'ep'">
                <v-card class="tnccard">
                    <v-card-title class="tnctitle">
                        <div class="modal-header">
                            <div src="../assets/images/logo_4iqBlack.svg" class="logo logocolor" title="Logo" alt="Constella Logo" width="150"></div>
                            <h2>Constella Acceptable Use Policy</h2>
                        </div>
                    </v-card-title>
                    <v-card-text class="tnctext">
                        <p v-html="templateData"></p>
                        <v-checkbox class="tnccheckbox" v-if="!fromheader" color="#5D1D99"
                            v-model="tncval" off-icon="check_box_outline_blank" on-icon="check_box"
                            :label="`Accept Terms of Use`"
                        ></v-checkbox>
                    </v-card-text>
                    <v-card-actions class="tncactions">
                        <v-spacer></v-spacer>
                        <template v-if="!fromheader">
                            <v-btn class="reject-btn" color="grey" flat @click="closeDialog">Reject</v-btn>
                            <v-btn class="accept-btn" :dark="tncval" color="#5D1D99" :class="!tncval ? 'btn-disabled' : ''" @click="accepttnc">Accept</v-btn>
                        </template>
                        <v-btn v-else color="blue darken-1" flat="flat" @click="closeDialog">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- </> app type not  ep  -->
            <!-- App type EP -->
            <v-dialog persistent scrollable v-model="dialog" width="40%" background-color="white" v-if="app == 'ep'">
                <div class="appTnc__main-container">
                    <div class="appTnc__text-container">
                        <div class="mainTitle_container">
                            <p>EVALUATION AGREEMENT</p>
                        </div>
                        <div class="text_container" id="tenantTncText">
                            <div v-html="templateData" class="subText__container"></div>
                            <v-checkbox v-model="agreeTncCheckBox" label="I agree to the terms of the Constella Evaluation Agreement"></v-checkbox>
                        </div>
                        <div class="footer_container">
                            <p @click="downloadFile()" class="download"><v-icon class="mr-1">icon-download_file</v-icon>Download</p>
                            <div class="actionButtons">
                                <v-btn class="cancel" depressed @click="closeDialog()">Cancel</v-btn>
                                <v-btn class="agree" depressed @click="accepttnc('ep')" :class="agreeTncCheckBox ? 'enable' : 'disable'">I AGREE</v-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </v-dialog>
            <!-- </> app type ep  -->
        </v-layout>
    </v-app>
</template>
<script>

import Vue from "vue";
import Vuetify from 'vuetify';
import Vuebar from 'vuebar';
import {hideLoadIcon,showLoadIcon} from '../assets/utils/load.js';

Vue.use(Vuetify);
Vue.use(Vuebar);

export default {
    name: "AppTerms",
    props: {
        session: {
            type: String
        },
        fromheader: {
            type: Boolean,
            default: false
        },
        app: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            templateData: '',
            tncval: false,
            dialog: false,
            hide:null,
            agreeTncCheckBox: false
        };
    },
    created() {
        var self = this;
        showLoadIcon();
        this.$loading(true);
        Vue.http.get('/terms_and_conditions/', {
            params:{
                'session' : self.session,
            }
        }).then((res)=>{
            try{
                if (res.data && (typeof res.data==='string' || res.data instanceof String)){
                    self.templateData = res.data;
                }
                else{
                    self.templateData = JSON.stringify(res.data);
                }
                if (self.app == 'ep') {
                    if (self.templateData.charAt(0) == '"' && self.templateData.charAt(self.templateData.length - 1) == '"') {
                        self.templateData = self.templateData.substring(1, self.templateData.length - 1);
                    }
                }
                self.dialog = true;
            } catch (err){
                // Must be an issue with response data type -->>
                console.log(err);
                self.templateData = res.data;
            }
            finally{
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
            }
        },(error)=>{
            self.hide = hideLoadIcon();
            if(!self.hide){
                this.$loading(false);
            }
            self.logout();
            //console.log("api failed with error");
        })
    },
    methods: {
        accepttnc(val){
            var self = this;
            var postData = {
                'session': self.session,
                'accept_tnc': val == 'ep' ? self.tncval : self.agreeTncCheckBox
            };
            $.ajax('/terms_and_conditions/',{
                type:'POST',
                data: postData,
                headers: {"ACCEPT": "application/json"},
                statusCode: {
                    200: function(data){
                        window.location = "/apps/"+data.app_name+"/index/?at="+data.session;
                    }
                }
            });
        },
        closeDialog(){
            this.dialog = false;
            this.$parent.showTnCView = false;
        },
        downloadFile() {
            var element = document.createElement('a');
            let text = 'Evaluation agreement\n\n' + document.getElementById('tenantTncText').innerText;
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', 'evaluation_agreement.txt');
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },
        showLoadIcon,
        hideLoadIcon
    }
};
</script>

<style lang="scss">
.tnccard{
    background-color: white;
}
.tnctext{
    width: 90%!important;
    border: 1px solid #e4dfd9;
    border-radius: 5px;
    background-color: #fafafa;
    padding: 20px 3%;
    margin: 0 5%;
}
.tnctitle{
    padding-top: 30px;
    justify-content: center;
}
.modal-header{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 0px;
}
.tncactions{
    margin: 20px 3% 20px;
}
.tncactions>.reject-btn:hover{
    color: black !important;
    background: #f2f2f2;
}
.tncactions>.accept-btn{
    color: rgb(180, 180, 180) !important;
}
.tncactions>.accept-btn:hover{
    color: white !important;
}
.tncactions>.accept-btn.btn-disabled{
    opacity: .5;
    pointer-events: none;
}
.tnccheckbox i{
    font-size: 2rem!important;
}
#inspire{
    position: absolute;
}

.v-dialog.v-dialog--active.v-dialog--persistent.v-dialog--scrollable {
    background-color: white;
    // height: 50%;
}
.appTnc__main-container {
    // width: 650px;
    height: auto;
    display: flex;
    margin: 2rem;
    // padding: 2rem 0rem;
    background-color: white;

    // Checkbox color & download color
    .theme--light.v-icon {
        // color: #C6C7C2;
    }
    
    .appTnc__text-container {
        width: inherit;
        // color: #EFEFEF;
        font-family: 'Roboto-light';
        font-weight: 600;

        .mainTitle_container {
            text-align: left;
            p {
                font-size: 20px;
            }
        }
        .text_container {
            font-size: 14px;

            .subText__container {
                div {
                    margin-bottom: 14px;
                }
            }

            .subtext {
                margin-bottom: 15px;

                ul li::marker {
                    font-size: 1.3rem;
                }
            }
            // checkbox label color
            .v-input--selection-controls__input+.v-label {
                // color: #EFEFEF;
            }

        }
        .footer_container {
            display: flex;
            // margin-top: 24px;
            justify-content: space-between;

            .download {
                margin-top: 22px;
                cursor: pointer;
                // color: white;
                margin-right: 24px;
            }
          
            .cancel {
                &.theme--light.v-btn.v-btn--has-bg {
                    background-color: transparent;
                    // border: 1px solid #638AFF;
                    font-weight: 600;
                    font-family: 'Roboto-Regular';
                    color: #638AFF;
                    margin-right: 24px;
                }
            }
            .agree {
                &.disable.theme--light.v-btn.v-btn--has-bg {
                    background-color: #5E5D60;
                    color: #98979A;
                    pointer-events: none;
                }
               
                &.enable.theme--light.v-btn.v-btn--has-bg {
                    background-color: #638AFF;
                    pointer-events: all;
                }
            }
            .v-btn {
                margin-top: 8px;
                font-weight: 600;
                height: 48px;
            }
            
            
        }
    }
}
</style>
